export default function ComparisonSection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px]">
      <div className="flex-1 relative overflow-hidden min-h-[300px] lg:min-h-[500px]">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20product%20flat%20lay%20with%20shoes%20bags%20and%20accessories%20arranged%20harmoniously%20on%20light%20limestone%20textured%20surface%20with%20warm%20natural%20sunlight%2C%20minimalist%20editorial%20photography%2C%20diverse%20neutral%20earthy%20color%20palette%20with%20subtle%20warm%20undertones%2C%20luxurious%20organic%20composition%20with%20airy%20feel&width=900&height=700&seq=compare-left-v2-layout&orientation=portrait"
          alt="OOPBuy Spreadsheet product comparison"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
        <div className="absolute top-6 left-6">
          <span className="text-xs font-medium text-background-50/80 tracking-widest uppercase bg-black/20 px-3 py-1 rounded-full">
            2026 Updated Guide
          </span>
        </div>
        <div className="absolute bottom-8 left-6 right-6">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
            Compare
            <br />
            Products
            <br />
            Instantly
          </h2>
        </div>
      </div>

      <div className="flex-1 bg-background-50 flex items-center justify-center p-8 md:p-16">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-6">
            How It
            <br />
            Works
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-10">
            OOPBuy Spreadsheet simplifies your shopping journey with a clean three-step process designed for maximum efficiency and transparency.
          </p>

          <div className="flex flex-col gap-6 mb-10">
            {[
              { step: "01", title: "Browse Structured Data", desc: "Access organized spreadsheet listings instead of scattered product pages" },
              { step: "02", title: "Compare & Filter", desc: "Evaluate products using price, quality, and availability metrics side by side" },
              { step: "03", title: "Redirect to Main Platform", desc: "Get guided to the main system for final actions and secure ordering" },
            ].map((item, i) => (
              <div key={i} className="flex gap-4 text-left">
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-accent-100 text-accent-600 flex items-center justify-center text-xs font-bold">
                  {item.step}
                </span>
                <div>
                  <h4 className="font-semibold text-foreground-900 text-sm">{item.title}</h4>
                  <p className="text-foreground-600 text-xs mt-1">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            Visit Official Platform
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}